(function($) { 'use strict';
    /**
     * Inbenta Namespace
     * @type {Object}
     */
    if (!window.InbentaCompagnon) window.InbentaCompagnon = {};

    var Server = $.extend({}, {
        default_settings: {
            type: 'POST',
            url: './',
            dataType: 'json',
            crossDomain: false,
            data: {},
            complete: function(response){},
            error: function(){},
            success: function(response){},
            start: function(){}
        },

        browser: {
            name: 'unknown',
            codeName: 'unknown',
            version: 'unknown',
            cookies: 'false',
            userAgent: 'unknown'
        },

        sessionId: null,

        initialize: function(settings)
        {
            this.default_settings = $.extend(true, this.default_settings, settings);
            this.loadSessionId();
            this.storeBrowserInfo();
        },

        storeBrowserInfo: function()
        {
            if (navigator && navigator.appName) this.browser.name = navigator.appName;
            if (navigator && navigator.appCodeName) this.browser.codeName = navigator.appCodeName;
            if (navigator && navigator.appVersion) this.browser.version = navigator.appVersion;
            if (navigator && navigator.cookieEnabled) this.browser.cookies = navigator.cookieEnabled;
            if (navigator && navigator.userAgent) this.browser.userAgent = navigator.userAgent;
        },

        send: function(settings, bind)
        {
            var sett = {};
            var _this = this;
            $.extend(true, sett, this.default_settings, settings);

            if (!sett.avoidBrowser) sett['data']['browser'] = this.browser;
            if (this.sessionId) sett['data']['sessionId'] = this.sessionId;

            var action = (settings.data && settings['data']['action']) ? settings['data']['action'] : null;
            var complete = sett['complete'] || function(){};
            var success = sett['success'];
            var error = sett['error'];
            var start = sett['start'];

            if (bind) {
                sett['complete'] = function(){};

                // success
                sett['success'] = function(response)
                {
                    if (!_this.sessionId || response['_reset_session_']) _this.setSessionId(response.sessionId);
                    if (action) response.action = action;
                    if (sett['callbackData']) response.callbackData = sett['callbackData'];
                    success.call(bind, response);
                    complete.call(bind, response);
                };

                // error
                sett['error'] = function(response)
                {
                    if (!_this.sessionId || response['_reset_session_']) _this.setSessionId(response.sessionId);
                    if (action) response.action = action;
                    if (sett['callbackData']) response.callbackData = sett['callbackData'];
                    error.call(bind, response);
                    complete.call(bind, false);
                };

                // start
                sett['start'] = function()
                {
                    var callbackData = sett['callbackData'] || {};
                    start.call(bind, action, callbackData);
                };
                start.call(bind, action, sett['callbackData'] || {});
            }else
            {
                sett['complete'] = function(){};

                // success
                sett['success'] = function(response)
                {
                    if (!_this.sessionId || response['_reset_session_']) _this.setSessionId(response.sessionId);
                    if (action) response.action = action;
                    if (sett['callbackData']) response.callbackData = sett['callbackData'];

                    success(response);
                    complete(response);
                };

                // error
                sett['error'] = function(response)
                {
                    if (!_this.sessionId || response['_reset_session_']) _this.setSessionId(response.sessionId);
                    if (action) response.action = action;
                    if (sett['callbackData']) response.callbackData = sett['callbackData'];
                    error(response);
                    complete(false);
                };

                // start
                sett['start'] = function()
                {
                    var callbackData = sett['callbackData'] || {};
                    start(action, callbackData);
                };
                sett['start'](action, sett['callbackData'] || {});
            }

            return $.ajax(sett);
        },

        /**
        * Session Id mantainace
        */
        loadSessionId: function()
        {
            var sessionId = null;
            var input = $('input[name="iaf-session"]');
            if (input.length) sessionId = input.val();
            if (sessionId) this.sessionId = sessionId;
        },

        setSessionId: function(sessionId)
        {
            this.sessionId = sessionId;

            var input = $('input[name="iaf-session"]');
            if (input.length) {
                input.val(sessionId);
            }
        },

        resetSessionId: function()
        {
            this.sessionId = null;
            $('input[name="iaf-session"]').remove();
        }
    });
    window.InbentaCompagnon.Server = Server;


    var ServerJSONP = $.extend({}, Server, {
        default_settings: {
            type: 'GET',
            url: null,
            dataType: 'jsonp',
            crossDomain: true,
            data: {},
            error: function(){},
            success: function(response){},
            start: function(){}
        },

        initialize: function(settings)
        {
            if(!($.cookie)) throw('ServerJSONP needs $.cookie plugin to work');
            if(!settings.url) throw('You must specify an url');

            this.sessionName = settings['sessionName'] || 'inbenta-session';
            this.default_settings = $.extend(true, this.default_settings, settings);
            this.loadSessionId();
            this.storeBrowserInfo();
        },

        /**
        * Session Id mantainace
        */
        loadSessionId: function()
        {
            var sessionId = $.cookie(this.sessionName);
            if (sessionId) {
                this.sessionId = sessionId;
            }
        },

        setSessionId: function(sessionId)
        {
            this.sessionId = sessionId;
            $.cookie(this.sessionName, this.sessionId, { path: '/', secure: true });
        },

        resetSessionId: function()
        {
            $.removeCookie(this.sessionName, { path: '/' });
            this.sessionId = null;
        }
    });
    window.InbentaCompagnon.Server.JSONP = ServerJSONP;
})(window.jQuery);
